import { capitalizeWords } from '@doveit/hammer';
import { CustomUser } from '../../../types';

export function getCustomUserShortName(user: CustomUser): string {
  if (user.given_name && user.family_name) {
    return `${user.given_name.charAt(0).toUpperCase()}. ${capitalizeWords(user.family_name)}`;
  }
  const [name, surname] = user.name.split(' ');
  return `${name.charAt(0).toUpperCase()}. ${capitalizeWords(surname)}`;
}
